
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment/distribution/[slug]",
      function () {
        return require("private-next-pages/investment/distribution/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investment/distribution/[slug]"])
      });
    }
  